import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import PropertyModel from "../models/PropertyModel";
import { useAuth } from "./AuthHook";

const PropertyContext = createContext();

export default function PropertyProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();
  const [currentProperty, setCurrentProperty] = useState(null);

  const getProperty = async (propertyId) => {
    try {
      logger.debug(
        "PropertyProvider.getProperty",
        `GET field/property/${propertyId}`
      );

      const data = await auth.get(`field/property/${propertyId}`);

      logger.debug(
        "PropertyProvider.getProperty",
        `Retrieved data for property '${propertyId}'`
      );

      const retrievedProperty = new PropertyModel(data);

      setCurrentProperty(retrievedProperty);

      return retrievedProperty;
    } catch (error) {
      logger.debug(
        "PropertyProvider.getProperty",
        `Failed to retrieve data for property '${propertyId}'`
      );
      return null;
    }
  };

  const selectedProperty = () => currentProperty;

  return (
    <PropertyContext.Provider
      value={{
        getProperty,
        selectedProperty,
      }}
    >
      {children}
    </PropertyContext.Provider>
  );
}

PropertyProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useProperty = () => useContext(PropertyContext);
